import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import type { StockControlRow } from '@econtractor/types';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import { useStockControlPage } from './model/useStockControlPage';
import StockControlToolBar from './StockControlToolBar';
import StockControlTable from './StockControlTable';
import OffStockControlFilter from './OffStockControlFilter';
import OffStockControlWarehouses from './OffStockControlWarehouses';

const StockControl = () => {
    const {
        t,
        rows,
        showSpinner,
        order,
        setOrder,
        desc,
        setDesc,
        filter,
        setFilter,
        showFilter,
        handleShowFilter,
        prevFilter,
        setPrevFilter,
        filterActive,
        triggerListReset,
        triggerListRefresh,
        showCategory,
        showArticle,
        toggleListColumn,
    } = useStockControlPage();
    const [opened, setOpened] = useState<StockControlRow | null>(null);

    return (
        <>
            <OffStockControlFilter
                show={showFilter}
                setShow={handleShowFilter}
                prevFilter={prevFilter}
                setPrevFilter={setPrevFilter}
                onApply={setFilter}
            />
            <OffStockControlWarehouses
                product={opened}
                filter={filter}
                onHide={() => setOpened(null)}
            />

            <Row>
                <Col className="col-sticky" sm={12}>
                    <div className="w-100 d-flex flex-column flex-xl-row pt-1 justify-content-between align-items-start gap-2 gap-xl-0">
                        <div>
                            <h4 className="mb-1">{t('stockControl.title')}</h4>
                            <TitleCounter />
                        </div>
                        <div className="warehouse-header-toolbar">
                            <StockControlToolBar
                                filterActive={filterActive}
                                onShowFilter={() => handleShowFilter(true)}
                                onReset={triggerListReset}
                                onRefresh={triggerListRefresh}
                                showCategory={showCategory}
                                showArticle={showArticle}
                                onToggleColumn={toggleListColumn}
                            />
                        </div>
                    </div>
                </Col>
                <Col sm={12}>
                    {rows == null ? (
                        <ESpinner />
                    ) : (
                        <StockControlTable
                            rows={rows}
                            showSpinner={showSpinner}
                            order={order}
                            desc={desc}
                            onOrder={(field, nextDesc) => {
                                setOrder(field);
                                setDesc(nextDesc);
                            }}
                            onOpen={setOpened}
                            showCategory={showCategory}
                            showArticle={showArticle}
                        />
                    )}
                </Col>
            </Row>
        </>
    );
};

export default StockControl;
